'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session'
import { urlWithParams } from '@marketplace-web/shared/utils'

import { clickEvent } from '_libs/common/event-tracker/events'
import { ITEM_UPLOAD_URL, SIGNUP_URL } from 'constants/routes'
import { ClickableElement } from 'constants/tracking/clickable-elements'
import { Screen } from 'constants/tracking/screens'

import { useSelectTypeUrl } from '@marketplace-web/domain/identity'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { ListingSectionModel } from '../../types'

type Props = { props: ListingSectionModel }

const ListingSection = ({ props }: Props) => {
  const { text, testId } = props
  const translate = useTranslate()
  const isListingCtaEnabled = useFeatureSwitch('dac7_listing_cta')
  const { track } = useTracking()
  const userId = useSession().user?.id
  const isNonNativeFlowAbTestEnabled = useAbTest('non_native_flow')?.variant === 'on'
  const selectTypeUrl = useSelectTypeUrl()

  const authenticationUrl = isNonNativeFlowAbTestEnabled ? selectTypeUrl : SIGNUP_URL

  const ctaUrl = userId
    ? ITEM_UPLOAD_URL
    : urlWithParams(authenticationUrl, {
        ref_url: ITEM_UPLOAD_URL,
      })

  const onCtaClick = () => {
    track(
      clickEvent({
        screen: Screen.NoChangesToTaxes,
        target: ClickableElement.CtaRedirect,
        targetDetails: `ready_to_go_start_selling__${userId ? ITEM_UPLOAD_URL : authenticationUrl}`,
      }),
    )
  }
  if (!isListingCtaEnabled) return null

  return (
    <section className="secondhand-taxes__listing-section" data-testid={testId}>
      <h3 className="secondhand-taxes__listing-section-title">{translate(text.title)}</h3>
      <div className="secondhand-taxes__listing-section-cta">
        <Button
          text={translate(text.cta)}
          inverse
          styling={Button.Styling.Filled}
          url={ctaUrl}
          onClick={onCtaClick}
        />
      </div>
    </section>
  )
}

export default ListingSection
